/* eslint-disable */
import React from 'react';
import SelectInput from '../select_input/SelectInput.jsx';
import TimeDropdown from '../Time/TimeDropdown.jsx';
import { NHB_MARKETS } from '../../constant.js';

const NHBTermsForm = ({
    phoneNumber, setPhoneNumber,
    eventDescription, setEventDescription,
    eventSpace, setEventSpace,
    nhbRestaurant, setNhbRestaurant,
    reservationDate, setReservationDate,
    eventTime, setEventTime,
    numberOfGuests, setNumberOfGuests,
    diningType, setDiningType,
    orderDeadline, setOrderDeadline,
    barType, setBarType,
    hostCap, setHostCap,
    checkType, setCheckType,
    reservationFee, setReservationFee,
    fbMinimum, setFbMinimum,
    additionalFees, setAdditionalFees,
}) => {

    return (
        <div>
            {/* Personal Info */}
            <div className="space-y-6 border-b border-gray-300 pb-10">
                <div>
                    <label htmlFor="phone-number" className="block text-sm font-medium text-gray-900 mb-1">
                        Phone Number
                    </label>
                    <input
                        id="phone-number"
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div>
                    <label htmlFor="event-description" className="block text-sm font-medium text-gray-900 mb-1">
                        Event Description
                    </label>
                    <textarea
                        id="event-description"
                        rows={4}
                        value={eventDescription}
                        onChange={(e) => setEventDescription(e.target.value)}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>
            </div>

            {/* Event Details */}
            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-3">
                    <label htmlFor="event-space" className="block text-sm font-medium text-gray-900">
                        Event Space
                    </label>
                    <input
                        id="event-space"
                        type="text"
                        value={eventSpace}
                        onChange={(e) => setEventSpace(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-3">
                    <label htmlFor="location" className="block text-sm font-medium text-gray-900">
                        North High Brewing Restaurant
                    </label>
                    <SelectInput
                        options={NHB_MARKETS}
                        value={NHB_MARKETS.find((item) => item.value === nhbRestaurant)}
                        setSelectedValue={(selected) => setNhbRestaurant(selected.value)}
                        placeholder="Choose a NHB Market"
                        className="mt-1"
                        required
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="date" className="block text-sm font-medium text-gray-900">
                        Date
                    </label>
                    <input
                        id="reservationDate"
                        type="date"
                        value={reservationDate}
                        onChange={(e) => setReservationDate(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="eventTime" className="block text-sm font-medium text-gray-900">
                        Event Time
                    </label>
                    <TimeDropdown
                      
                        value={eventTime}
                        onChange={setEventTime}
                    />  
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="total-guests" className="block text-sm font-medium text-gray-900">
                        Number of Guests
                    </label>
                    <input
                        id="total-guests"
                        type="text"
                        value={numberOfGuests}
                        onChange={(e) => setNumberOfGuests(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>
            </div>

            {/* Reservation Info */}
            <div className="mt-4 space-y-6 border-b border-gray-300 pb-10 ">
                <p className="text-sm text-right text-gray-600">
                    *Reservations are secured after the Reservation Fee is paid (non-refundable)
                </p>
            </div>

            {/* Dining Details */}
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-3">
                    <label htmlFor="dining-type" className="block text-sm font-medium text-gray-900">
                        Dining Type
                    </label>
                    <input
                        id="dining-type"
                        type="text"
                        value={diningType}
                        onChange={(e) => setDiningType(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-3">
                    <label htmlFor="order-deadline" className="block text-sm font-medium text-gray-900">
                        Order Deadline
                    </label>
                    <input
                        id="order-deadline"
                        type="text"
                        placeholder="N/A"
                        value={orderDeadline}
                        onChange={(e) => setOrderDeadline(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="bar-type" className="block text-sm font-medium text-gray-900">
                        Bar Type
                    </label>
                    <input
                        id="bar-type"
                        type="text"
                        value={barType}
                        onChange={(e) => setBarType(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="host-cap" className="block text-sm font-medium text-gray-900">
                        Host Cap (if applicable)
                    </label>
                    <input
                        id="host-cap"
                        type="text"
                        placeholder="TBD/NA"
                        value={hostCap}
                        onChange={(e) => setHostCap(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="check-type" className="block text-sm font-medium text-gray-900">
                        Check Type
                    </label>
                    <input
                        id="check-type"
                        type="text"
                        value={checkType}
                        onChange={(e) => setCheckType(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>
            </div>

            {/* Fee Section */}
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-2 sm:col-start-1">
                    <label htmlFor="reservation-fee" className="block text-sm font-medium text-gray-900">
                        Reservation Fee*
                    </label>
                    <input
                        id="reservation-fee"
                        type="text"
                        value={reservationFee}
                        onChange={(e) => setReservationFee(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="fb-minimum" className="block text-sm font-medium text-gray-900">
                        F&B Minimum
                    </label>
                    <input
                        id="fb-minimum"
                        type="text"
                        value={fbMinimum}
                        onChange={(e) => setFbMinimum(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="additional-fees" className="block text-sm font-medium text-gray-900">
                        Additional Fees
                    </label>
                    <input
                        id="additional-fees"
                        type="text"
                        placeholder="N/A"
                        value={additionalFees}
                        onChange={(e) => setAdditionalFees(e.target.value)}
                        className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                    />
                </div>
            </div>

            {/* Footnote */}
            <div className="mt-4 space-y-4 border-b border-gray-300 pb-10 ">
                <p className="text-sm text-right text-gray-600">
                    *Reservations are secured after the Reservation Fee is paid (non-refundable)
                </p>
                <p className="text-sm text-right text-gray-600">
                    A 20% gratuity will be automatically applied to parties larger than 15.
                </p>
            </div>

            {/* Optional Footer (commented out) */}
            {/*
            <p className="text-sm text-left text-gray-600 mt-4">
                Prepared by: Tyra Pouncy, Private Event Manager
            </p>
            <p className="text-sm text-left text-gray-600">
                Date & Time:
            </p>
            */}
        </div>
    );
};

export default NHBTermsForm;
